export default __webpack_public_path__ + "static/media/pgmico(35).5bfeac29.png";